// Zahlen der Berichte lesbar machen: Anzahl, Dauer, Euro, Prozent (deutsches Format).
import type { KennzahlEinheit } from "../api/berichte";

const zahl = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 1 });
const ganz = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 });
const euroFormat = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

/** Sekunden als „56 s“, „5 Min 12 s“ oder „5 Std 13 Min“. */
export function dauerText(sekunden: number | null | undefined): string {
  if (sekunden === null || sekunden === undefined) return "–";
  const s = Math.round(sekunden);
  if (s < 60) return `${s} s`;
  if (s < 3600) return `${Math.floor(s / 60)} Min ${s % 60} s`;
  return `${Math.floor(s / 3600)} Std ${Math.floor((s % 3600) / 60)} Min`;
}

export function wertText(wert: number | null | undefined, einheit: KennzahlEinheit): string {
  if (wert === null || wert === undefined) return "–";
  switch (einheit) {
    case "sekunden": return dauerText(wert);
    case "euro": return euroFormat.format(wert);
    case "prozent": return `${zahl.format(wert)} %`;
    default: return ganz.format(wert);
  }
}

/** Veränderung gegenüber dem Vergleich: „+12,5 %“; ohne Vergleichswert leer. */
export function veraenderungText(prozent: number | null | undefined): string {
  if (prozent === null || prozent === undefined) return "";
  return `${prozent > 0 ? "+" : ""}${zahl.format(prozent)} %`;
}

export const zahlText = (n: number | null | undefined) => (n === null || n === undefined ? "–" : zahl.format(n));
export const ganzText = (n: number | null | undefined) => (n === null || n === undefined ? "–" : ganz.format(n));
export const euroText = (n: number | null | undefined) => (n === null || n === undefined ? "–" : euroFormat.format(n));

/** CSV-Download im Browser: Text mit BOM (Excel) als Datei. */
export function herunterladen(dateiname: string, csv: string): void {
  const text = csv.startsWith("﻿") ? csv : "﻿" + csv;
  const url = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = dateiname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
